import { defineMessages } from "react-intl";

export default defineMessages({
  pay: {
    id: "payWithBancontact.pay",
    defaultMessage: "Pay {amount}",
  },
  youWillBeRedirectedToYourBank: {
    id: "payWithBancontact.youWillBeRedirectedToYourBank",
    defaultMessage: "You will be redirected to your bank",
  },
});
